module.exports = __webpack_public_path__ + "static/media/rect.b7c3f6cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rect.svg
// module id = 271
// module chunks = 0